import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { HelmetProvider } from "react-helmet-async";
import logger from "./lib/logger";
import reportWebVitals, {
  sendToGoogleAnalytics,
} from "./utils/reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

const enablePWA =
  process.env.NODE_ENV === "production" ||
  process.env.REACT_APP_ENABLE_PWA === "true";

if (enablePWA) {
  // Register service worker for PWA functionality when opted-in
  serviceWorkerRegistration.register({
    onSuccess: () => logger.debug("[PWA] App cached for offline use"),
    onUpdate: (registration) => {
      logger.debug("[PWA] New version available");
      // You can show a toast notification here
    },
  });
} else {
  // Ensure dev/CI environments do not cache old chunks which can break lazy routes
  serviceWorkerRegistration.unregister();
}

// Report Core Web Vitals for performance monitoring
reportWebVitals(sendToGoogleAnalytics);
